import { useMemo } from 'react'
import { useParams, Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { useClient } from '@/modules/clients/hooks/useClient'
import { ClientForm } from '@/modules/clients/components/ClientForm'
import { useClientMutation } from '@/modules/clients/hooks/useClientMutation'
import { ErrorState } from '@/shared/components/ui/atoms/ErrorState'

export function ClientEditPage() {
  const { id } = useParams<{ id: string }>()
  const clientId = Number(id)
  const { data, isLoading, error: loadError } = useClient(clientId)
  const { update, isSubmitting, error: mutationError } = useClientMutation()

  const formDefaults = useMemo(() => {
    if (!data) return undefined
    return {
      ...data,
      // <input type="date"> expects YYYY-MM-DD, strip time if present
      birthdate: data.birthdate ? data.birthdate.split('T')[0] : '',
    }
  }, [data])

  if (isLoading) {
    return <div className="animate-pulse h-96 bg-gray-100 rounded-lg" />
  }

  if (loadError) {
    return <ErrorState message={loadError} />
  }

  if (!data) return null

  return (
    <div>
      <div className="flex items-center gap-3 mb-6">
        <Link to={`/clients/${clientId}`} className="text-gray-500 hover:text-gray-700">
          <ArrowLeft size={20} />
        </Link>
        <h1 className="text-2xl font-bold text-gray-900">Editar Cliente</h1>
      </div>
      <div className="card p-6">
        <ClientForm
          defaultValues={formDefaults}
          onSubmit={(formData) => update(clientId, formData)}
          isSubmitting={isSubmitting}
          error={mutationError}
        />
      </div>
    </div>
  )
}
